import "./Splash.scss";

import React from "react";

const Splash = () => {
  return (
    <div className="hallapp-splash" aria-label="Tela de carregamento do Hallapp">
      {/* Fundo decorativo */}
      <div className="hallapp-splash__bg" aria-hidden="true" />
      <div className="hallapp-splash__noise" aria-hidden="true" />

      {/* Orbes */}
      <span className="hallapp-splash__orb orb-1" aria-hidden="true" />
      <span className="hallapp-splash__orb orb-2" aria-hidden="true" />
      <span className="hallapp-splash__orb orb-3" aria-hidden="true" />

      {/* Conteúdo */}
      <div className="hallapp-splash__content">
        <div className="hallapp-splash__logoWrap" aria-label="Logo HallApp">
          <div className="hallapp-splash__glow" aria-hidden="true" />
          <div className="hallapp-splash__ring" aria-hidden="true" />

          <div className="hallapp-splash__logo" aria-hidden="true">
            <span
              className="hallapp-appnameH"
              style={{ "--w": "96px", "--c": "#fff" }}
            >
              <i className="hallapp-appnameH__bar" />
            </span>
          </div>

          <div className="hallapp-splash__shimmer" aria-hidden="true" />
        </div>

        <div className="hallapp-splash__title">Hallapp</div>
        <div className="hallapp-splash__subtitle">
          Organizando seu salão com inteligência
        </div>

        <div className="hallapp-splash__loading" aria-label="Carregando">
          <span className="hallapp-splash__loadingText">Carregando</span>
          <span className="hallapp-splash__dots" aria-hidden="true">
            <i />
            <i />
            <i />
          </span>
        </div>
      </div>

      {/* Rodapé */}
      <div className="hallapp-splash__footer">
        <span className="hallapp-splash__tag">Powered by HallApp</span>
      </div>
    </div>
  );
};

export default Splash;
